var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-container message-container--error",class:{hide: !_vm.errorMessage},on:{"click":_vm.clearErrorMessage}},[(_vm.errorMessage)?_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-times message-close"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e68882a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ErrorMessageComponent.vue
// module id = Y5Pz
// module chunks = 0